module.exports = __webpack_public_path__ + "static/media/box.728811dc.svg";